/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GcpPolicyResponse } from './gcpPolicyResponse';


export interface GcpImageResponse { 
    /**
     * Image Id
     */
    id?: number;
    /**
     * Name/Key of a Image.
     */
    name: string;
    /**
     * Version of a Image
     */
    version: string;
    /**
     * Source Image Name
     */
    source_image?: string;
    region_id?: string;
    size_gb?: number;
    status: string;
    /**
     * Creation timestamp
     */
    create_time: Date;
    self_link?: string;
    policy: GcpPolicyResponse;
}

